export const hardwarePage = {
  path: '/hardware',
  images: {
    hero: '/hardware-terminal.webp',
    section1: '/hardware-terminal.webp', // Accept any card
    section2: '/hardware-stand.webp', // The command station
    section3: '/hardware-kds.webp', // Kitchen display
    section4: '/hardware-printer.webp', // Receipts & printing
    section5: '/hardware-stand.webp', // Modular hardware
  },
  seoTitle: 'POS System Hardware & Cash Register Alternatives | Tillio',
  seoDescription:
    'Restaurant POS hardware: Stripe Terminal card readers, printers, cash drawers, stands, and tablets. Suggested products for Tillio.',
  hero: {
    title: 'Hardware for Tillio POS',
    description:
      'Suggested and compatible equipment for restaurants—card readers, printers, stands, and cash drawers. Mix and match instead of buying a locked-in cash register.',
  },
  sections: [
    {
      title: 'Accept any card.',
      description:
        'Pair Stripe Terminal readers with Tillio POS and accept chip, swipe, and tap—1.1% Tillio flat rate plus Stripe’s processing fees.',
      bullets: [
        'End-to-end encryption and PCI compliance',
        'Chip, swipe, and tap payments',
        'Dispute handling support',
      ],
    },
    {
      title: 'The command station.',
      description:
        'Sync tablets for POS, tickets, and customer display. Pair with a stand built for restaurant counters.',
      bullets: [
        'Cable concealment for a clean counter',
        'Swivel or pivot for customer-facing display',
        'Built for restaurant environments',
      ],
    },
    {
      title: 'Kitchen display',
      description: 'Send every ticket to an organized digital queue instead of a stack of paper chits.',
    },
    {
      title: 'Receipts & printing',
      description:
        'Digital receipts by email or text, plus thermal printers for stations that still need paper.',
      bullets: [
        'Email and phone receipt options',
        'Thermal printers for FOH and prep',
        'Less clutter at expo',
      ],
    },
    {
      title: 'Modular hardware for growing restaurants',
      description: '',
      bullets: [
        'Mix and match devices',
        'Unlimited devices at no extra software cost',
        'Support for devices you already own',
      ],
    },
  ],
}
